import axios from 'axios';

const getMoedasComprador = (params) => axios.get('/fornecedor/configuracoes-moedas', { params });

export default {
  getMoedasComprador,
};
